import React, { MouseEvent } from "react";
import { trustedLogos } from "../data";

const workshopImage = require("../../../../../../assets/images/workshops/42courses-workshops.jpeg");

const scrollToSection = (
  event: MouseEvent<HTMLAnchorElement>,
  sectionId: string,
) => {
  const target = document.getElementById(sectionId);
  if (!target) return;

  event.preventDefault();
  window.history.pushState(null, "", `#${sectionId}`);
  window.scrollTo({
    top: target.getBoundingClientRect().top + window.scrollY,
    behavior: "smooth",
  });
};

const Hero = () => (
  <header className="workshops-hero" role="banner">
    <div className="hero-pattern" aria-hidden="true">
      <svg
        className="bg"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <svg x="4%" y="20%" overflow="visible">
          <use
            href="#workshop-blob-1"
            fill="#FFA5BC"
            transform="scale(2.4)"
            opacity="0.18"
          ></use>
        </svg>
        <svg x="86%" y="78%" overflow="visible">
          <use
            href="#workshop-blob-2"
            fill="#B798F2"
            transform="scale(2.7)"
            opacity="0.16"
          ></use>
        </svg>
        <svg x="52%" y="-12%" overflow="visible">
          <use
            href="#workshop-blob-3"
            fill="#E8EBFF"
            transform="scale(2.0)"
            opacity="0.55"
          ></use>
        </svg>
        <svg x="70%" y="60%" overflow="visible">
          <use
            href="#workshop-blob-1"
            fill="#F3EC7A"
            transform="scale(1.3)"
            opacity="0.32"
          ></use>
        </svg>
        <svg x="14%" y="76%" overflow="visible">
          <use
            href="#workshop-blob-2"
            fill="#F3EC7A"
            transform="scale(1.0)"
            opacity="0.28"
          ></use>
        </svg>
      </svg>
    </div>
    <div className="container workshops-hero__container">
      <div
        className="workshops-hero__trust-strip"
        aria-labelledby="trust-label"
      >
        <p className="workshops-hero__trust-label" id="trust-label">
          Teams we've trained
        </p>
        <div className="workshops-hero__trust-logos" role="list">
          <span className="trust-logo" role="listitem">
            HSBC
          </span>
          <span className="trust-logo" role="listitem">
            Ogilvy
          </span>
          <span className="trust-logo" role="listitem">
            PwC
          </span>
          <span className="trust-logo" role="listitem">
            Omnicom
          </span>
        </div>
      </div>

      <div className="workshops-hero__grid">
        <div className="workshops-hero__content">
          <span className="workshops-hero__eyebrow">Live Workshops</span>
          <h1>
            AI workshops that <em>outlast</em> the workshop.
          </h1>
          <p className="workshops-hero__lede">
            Half-day and bespoke programmes for leaders, marketers and makers.
          </p>
          <div className="workshops-hero__actions">
            <a
              href="#enquire"
              className="workshops-hero__button workshops-hero__button--primary"
              onClick={(event) => scrollToSection(event, "enquire")}
            >
              Book a workshop
            </a>
            <a
              href="#workshops"
              className="workshops-hero__button workshops-hero__button--outline"
              onClick={(event) => scrollToSection(event, "workshops")}
            >
              See the formats
            </a>
          </div>
        </div>

        <div className="workshops-hero__photo">
          <img
            src={workshopImage}
            alt="42courses workshop participants with certificates"
          />
        </div>
      </div>
    </div>
  </header>
);

export default Hero;
